import { buildOrderItems } from 'components/Sell/OrderLookup/OrderInfo/buildOrderToOrderViewModel'
import Decimal from 'decimal.js'
import {
    OrderLineKdsStatus,
    OrderLineLookupContract,
    OrderLineStatus,
} from 'models'
import { useCallback } from 'react'
import { OrderItemViewModel } from 'store/models/sellModels'
import OrderItemViewError from 'store/utils/OrderItemViewError'
import { usePosContext } from 'views/Sale/contexts/PosProvider'
import { useSaleDependenciesContext } from 'views/Sale/contexts/SaleDependenciesContext'
/**
 * required useSaleDependenciesContext
 * @returns {convertToOrderItemViewModels:()=>void}
 */
const useBuildOrderItems = () => {
    const saleState = useSaleDependenciesContext()
    const {
        strictTimeAvailabilityOnSales,
        disableProductSelectionForOutOfStockItems: enableInventoryCheck,
    } = usePosContext()

    /** Helper function to Convert from `Array<OrderLineLookupContract>` to `Array<OrderItemViewModel>` */
    const convertToOrderItemViewModels = useCallback(
        (lines: OrderLineLookupContract[]) => {
            const orderItems = buildOrderItems(
                lines,
                {
                    itemsMap: saleState.itemsMap,
                    variantGroupsMap: saleState.variantGroupsMap,
                    modifierList: saleState.modifierList,
                    modifierOptionsMap: saleState.modifierOptionsMap,
                    comboChoicesMap: saleState.comboChoicesMap,
                    discounts: saleState.discounts,
                    priceListData: saleState.priceListData,
                },
                new OrderItemViewError(
                    strictTimeAvailabilityOnSales,
                    saleState.menus!,
                    saleState.comboChoicesMap,
                    saleState.unavailableProducts,
                    enableInventoryCheck ?? false,
                    saleState.modifierOptionsMap,
                    saleState.priceListData,
                    saleState.variantGroupsMap,
                    saleState.modifierGroupsMap,
                    saleState.itemsMap,
                    saleState.entityModifiersMap,
                ),
            )

            return orderItems
        },
        [
            enableInventoryCheck,
            saleState.comboChoicesMap,
            saleState.discounts,
            saleState.itemsMap,
            saleState.variantGroupsMap,
            saleState.modifierList,
            saleState.modifierOptionsMap,
            saleState.priceListData,
            saleState.menus,
            saleState.unavailableProducts,
            saleState.modifierGroupsMap,
            saleState.entityModifiersMap,
            strictTimeAvailabilityOnSales,
        ],
    )
    const onReorderLines = useCallback(
        (
            l: OrderLineLookupContract[],
            addItems: (l: OrderItemViewModel[]) => void,
        ) => {
            const lines = convertToOrderItemViewModels(l)
            const newLines = lines.orderItems.map<OrderItemViewModel>((l) => {
                return {
                    ...l,
                    isSaved: false,
                    status: OrderLineStatus.New,
                    kdsStatus: OrderLineKdsStatus.Unknown,
                    id: `reorder-${l.id}`,
                    subtotal: new Decimal(0),
                }
            })
            addItems(newLines)
        },
        [convertToOrderItemViewModels],
    )
    return { convertToOrderItemViewModels, onReorderLines }
}
export default useBuildOrderItems
